import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _construct from "@babel/runtime/helpers/construct";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export function connect(flows) {
  return function init(Target) {
    return function create() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var Platform = _construct(Target, args);

      var types = Object.keys(flows);
      var instances = {};
      return types.reduce(function (scope, type) {
        var Fragment = flows[type];

        var OneUDB = /*#__PURE__*/function (_Fragment) {
          _inherits(OneUDB, _Fragment);

          var _super = _createSuper(OneUDB);

          function OneUDB() {
            var _this;

            _classCallCheck(this, OneUDB);

            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            _this = _super.call.apply(_super, [this].concat(args));

            _defineProperty(_assertThisInitialized(_this), "_storage", Platform);

            _defineProperty(_assertThisInitialized(_this), "_requestor", Platform);

            return _this;
          }

          return _createClass(OneUDB);
        }(Fragment);

        Object.defineProperty(scope, type, {
          value: OneUDB
        });
        return scope;
      }, instances);
    };
  };
}